import { useEffect } from "react";

// Hook that is used to render title for Routes/Pages. Using a hook for uniformity across the app
export const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return;
};
